import Container from '@cloudscape-design/components/container'
import Header from '@cloudscape-design/components/header'
import SpaceBetween from '@cloudscape-design/components/space-between'
import Button from '@cloudscape-design/components/button'
import Box from '@cloudscape-design/components/box'
import { signInWithFederatedIdp } from '@/engine/cognito-auth'

interface Props {
  onSuccess?: () => void
}

export function SignInPage(_props: Props) {
  return (
    <div style={{ maxWidth: 440, margin: '80px auto', padding: '0 24px' }}>
      <Container header={<Header variant="h1">Sign In Required</Header>}>
        <SpaceBetween size="m">
          <Box color="text-body-secondary">
            Sign in with your Amazon Midway credentials to access Bedrock Latency Diagnostics.
          </Box>
          <Button
            variant="primary"
            onClick={() => signInWithFederatedIdp('Midway-bedrock-latency')}
            fullWidth
            iconName="lock-private"
          >
            Sign in with Midway
          </Button>
        </SpaceBetween>
      </Container>
    </div>
  )
}
